import { Image as TiptapImage } from 'tiptap-extensions'
import { Plugin } from 'tiptap'

const originalSchema = Object.getOwnPropertyDescriptor(
  TiptapImage.prototype,
  'schema',
)

Object.defineProperty(TiptapImage.prototype, 'schema', {
  configurable: true,
  get() {
    const schema = originalSchema.get.call(this)
    schema.attrs.width = { default: null }
    schema.parseDOM = [
      {
        tag: 'img[src]',
        getAttrs: (dom) => ({
          src: dom.getAttribute('src'),
          title: dom.getAttribute('title'),
          alt: dom.getAttribute('alt'),
          width: dom.getAttribute('width'),
        }),
      },
    ]
    schema.toDOM = (node) => {
      const attrs = { src: node.attrs.src }
      if (node.attrs.alt) attrs.alt = node.attrs.alt
      if (node.attrs.title) attrs.title = node.attrs.title
      if (node.attrs.width) attrs.width = node.attrs.width
      return ['img', attrs]
    }
    return schema
  },
})

class ResizableImageView {
  constructor(node, view, getPos) {
    this.node = node
    this.view = view
    this.getPos = getPos

    this.dom = document.createElement('span')
    Object.assign(this.dom.style, {
      display: 'inline-block',
      position: 'relative',
      lineHeight: '0',
      maxWidth: '100%',
    })

    this.img = document.createElement('img')
    this.img.src = node.attrs.src
    if (node.attrs.alt) this.img.alt = node.attrs.alt
    if (node.attrs.title) this.img.title = node.attrs.title
    Object.assign(this.img.style, {
      maxWidth: '100%',
      height: 'auto',
      display: 'block',
    })
    if (node.attrs.width) this.img.style.width = node.attrs.width + 'px'
    this.dom.appendChild(this.img)

    this.handle = document.createElement('span')
    Object.assign(this.handle.style, {
      position: 'absolute',
      bottom: '4px',
      right: '4px',
      width: '14px',
      height: '14px',
      backgroundColor: '#1976d2',
      border: '2px solid #ffffff',
      borderRadius: '3px',
      cursor: 'nwse-resize',
      zIndex: '10',
      boxShadow: '0 0 2px rgba(0,0,0,0.4)',
    })
    this.dom.appendChild(this.handle)

    this.onMouseDown = this.onMouseDown.bind(this)
    this.handle.addEventListener('mousedown', this.onMouseDown)
  }

  onMouseDown(event) {
    event.preventDefault()
    event.stopPropagation()

    const startX = event.clientX
    const startWidth = this.img.offsetWidth

    const onMove = (moveEvent) => {
      const dx = moveEvent.clientX - startX
      const newWidth = Math.max(50, startWidth + dx)
      this.img.style.width = newWidth + 'px'
    }

    const onUp = () => {
      document.removeEventListener('mousemove', onMove)
      document.removeEventListener('mouseup', onUp)

      const finalWidth = this.img.offsetWidth
      const transaction = this.view.state.tr.setNodeMarkup(
        this.getPos(),
        null,
        { ...this.node.attrs, width: finalWidth },
      )
      this.view.dispatch(transaction)
    }

    document.addEventListener('mousemove', onMove)
    document.addEventListener('mouseup', onUp)
  }

  update(node) {
    if (node.type !== this.node.type) return false
    this.node = node
    if (this.img.src !== node.attrs.src) this.img.src = node.attrs.src
    this.img.style.width = node.attrs.width ? node.attrs.width + 'px' : ''
    return true
  }

  selectNode() {
    this.dom.style.outline = '2px solid #1976d2'
  }

  deselectNode() {
    this.dom.style.outline = ''
  }

  destroy() {
    this.handle.removeEventListener('mousedown', this.onMouseDown)
  }
}

const originalPlugins = Object.getOwnPropertyDescriptor(
  TiptapImage.prototype,
  'plugins',
)

Object.defineProperty(TiptapImage.prototype, 'plugins', {
  configurable: true,
  get() {
    const plugins = originalPlugins.get.call(this)
    return [
      ...plugins,
      new Plugin({
        props: {
          nodeViews: {
            image: (node, view, getPos) =>
              new ResizableImageView(node, view, getPos),
          },
        },
      }),
    ]
  },
})
